export const formRowSizes = {
    full: 12,
    half: 6,
    small: 4,
    xs: 2,
    mid: 8
}